import React from "react";

/**
 * Label component that renders form labels with optional small styling
 * Provides consistent label styling and accessibility features across forms
 * 
 * @param {Object} props - Component props
 * @param {string} props.label - The text content to display in the label
 * @param {string} props.labelfor - The ID of the form element this label is associated with (htmlFor attribute)
 * @param {boolean} props.small - Whether to apply small text styling (default: false)
 */
const Label = ({ label, labelfor, small }) => (
    <label className={`${small ? "labelsmall" : ""}`} htmlFor={labelfor}>
        {label}
    </label>
);

export default Label;
